"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SWAP_MIN_AMOUNTS = void 0;
const enums_1 = require("../enums");
exports.SWAP_MIN_AMOUNTS = {
    [enums_1.SystemCurrency.OKLP]: 50,
    [enums_1.SystemCurrency.USDT]: 0.25,
};
//# sourceMappingURL=swap.js.map